<template>
  <div class="box">
    <!-- <div class="select">
      <form action="/">
        <van-search
          v-model="enterpriseName"
          background="#fff"
          clearable
          placeholder="搜索旅行社名称或景区名称"
        />
      </form>
    </div> -->
    <div class="select">
      <div class="searchBox">
        <img src="../../../../assets/image/sousuo_ic_daoyou @2x (1).png"/>
        <img v-if="enterpriseName" @click="cancel" src="../../../../assets/appointment/ic_close_sousuo@3x.png"/>
        <input type="text" v-model="enterpriseName" :placeholder="searchPlaceHolder" autofocus id="focusInput"/>
      </div>
    </div>
    <div>
      <div class="box2">
          <ul>
            <li
              class="line_bottom"
              v-for="(item,index) in filterList"
              :key="index"
              @click="goScoreDetails(item)"
            >
              <div class="score">
                <div class="left">
                  <div
                    class="businessName"
                    :class="{businessNameWidth: !item.isBlackList && !item.isSupervision}"
                  >
                    <!-- <span>{{item.name.slice(0, item.name.indexOf(enterpriseName))}}</span>-- -->
                    <!-- <span
                      class="highlight"
                    >{{item.name.slice(item.name.indexOf(enterpriseName),item.name.indexOf(enterpriseName)+enterpriseName.length)}}</span>
                    <span>{{item.name.substr(item.name.indexOf(enterpriseName)+enterpriseName.length)}}</span> -->
                    <span>{{ item.name }}</span>
                  </div>
                </div>
              </div>
              <div class="adress">{{item.type}}</div>
            </li>
          </ul>
      </div>
    </div>
    <div class="tipsBox" v-if="isShowTips">
      <img class="tipsImgBox" src="../../../../assets/image/ic_wusousuo@3x.png" alt />
      <p class="tipsText">当前搜索无结果</p>
      <p>请核对信息后进行搜索</p>
    </div>
  </div>
</template>
<script>
import api from "../../../../service/modules/integrity";
import appointment from "@/service/modules/appointment";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      finishedText: "",
      enterpriseName: "",
      dataSource: [],
      filterList: [],
      areaCode: '',
      type: "all",
      isShowTips: false,
      searchType: 1,
      searchPlaceHolder: '搜索旅行社名称或景区名称'
    };
  },
  watch: {
    enterpriseName(e) {
      this.enterpriseName = e;
      let val = e.toLowerCase();
      this.filterList = [];
      if (val === "") {
        this.isShowTips = false;
      }
      this.dataSource.forEach(item => {
        if (item.name && item.name.toLowerCase().indexOf(val) != '-1' && val != '') {
          this.filterList.push(item)
        }
      })
    }
  },
  created() {
    this.areaCode = JSON.parse(localStorage.getItem("auth")).areaCode;
    this.searchType = this.$route.query.searchType;
    if (this.searchType === 2) {
      this.searchPlaceHolder = '搜索景区名称';
    }
    this.queryOrgAndTravelAgencyList();
  },
  methods: {
    // 获取检索接口数据
    queryOrgAndTravelAgencyList() {
      let params = {
        areaCode: this.areaCode
      }
      appointment.queryOrgAndTravelAgencyList(params).then(res => {
        this.dataSource = [];
        this.filterList = [];
        if (res.ret === 0) {
          if (res.data.length > 0) {
            res.data.forEach(element => {
              if (this.searchType === 2) {
                if (element.type === '景区') {
                  this.dataSource.push(element);
                }
              } else {
                this.dataSource.push(element);
              }
            });
          }
        }
      });
    },
    cancel () {
      this.enterpriseName = '';
      this.filterList = '';
    },
    onLoad() {
      this.queryOrgAndTravelAgencyList();
    },
    goScoreDetails(e) {
      this.$router.replace({
        path: '/appointment/home/list',
        query: {
          orgId: e.type === '景区' ? e.id : '',
          travelId: e.type === '旅行社' ? e.id : '',
          scenicName: e.type === '景区' ? e.name : '',
          travelName: e.type === '旅行社' ? e.name : '',
          appointmentType: this.$route.query.appointmentType
        }
      })
    },
  },
  mounted() {
    let input = document.getElementById('focusInput');
    input.focus();
  }
};
</script>
<style lang="less" scoped>
.van-search {
  padding: 12px 16px;
}
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  .select {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #fff;
    z-index: 999;
  }
  .searchBox {
      height: 36px;
      line-height: 36px;
      margin: 12px 16px 0 16px;
      background-color: #fff;
      border: 1px solid #eee;
      border-radius: 3px;
      box-sizing: border-box;
      position: relative;
      font-size: 14px;

      > img:nth-child(1) {
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 10px;
        left: 14px;
      }

      > img:nth-child(2) {
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 10px;
        right: 14px;
      }

      > input {
        font-family: PingFang SC;
        width: 100%;
        height: 28px;
        line-height: 28px;
        padding: 0 16px 0 40px;
        box-sizing: border-box;
        border-radius: 2px;
        background-color: #fff;
      }
      input::-webkit-input-placeholder {
        color: #999999;
      }
      input::-moz-input-placeholder {
        color: #999999;
      }
      input::-ms-input-placeholder {
        color: #999999;
      }
    }
  .line_bottom::after {
    background-color: transparent;
  }
  .box2 {
    width: 100%;
    height: 100%;
    padding: 58px 16px 12px 16px;
    // padding-top: 58px;
    ul {
      width: 100%;
      background-color: #fff;
      li:last-child {
        border-bottom: none;
      }
      li {
        list-style: none;
        box-sizing: border-box;
        padding: 10px 0;
        font-size: 14px;
        overflow: hidden;
        .score {
          color: #333;
          display: flex;
          justify-content: space-between;
          font-weight: Medium;
          overflow: hidden;
          .left {
            display: flex;
            justify-content: left;
            .businessName {
              line-height: 18px;
              font-size: 14px;
              font-weight: 400;
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .highlight {
                color: @base-color;
                font-weight: 400;
              }
            }
            .businessNameWidth {
              max-width: 260px;
            }
            .tag {
              line-height: 18px;
              font-size: 12px;
              height: 18px;
              margin-left: 4px;
              -webkit-transform: scale(0.84);
              margin: 0px 3px 0 3px;
              padding: 0 3px 2px 3px;
              text-align: center;
              color: #ff4d4d;
            }
            .callout {
              display: inline-block;
              height: 18px;
              line-height: 18px;
              margin-top: -1px;
              margin-left: 4px;
              padding: 0 8px;
              box-sizing: border-box;
              // border: 1px solid #ff4d4d;
              color: #ff4d4d;
              font-size: 10px;
              font-weight: Regular;
            }
          }
          .right {
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
          }
        }
        .adress {
          color: #999;
          margin-top: 8px;
          width: 80%;
          line-height: 20px;
          font-size: 12px;
        }
      }
    }
  }
  .tipsBox {
    width: 140px;
    color: #999999;
    font-size: 14px;
    text-align: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .tipsImgBox {
      width: 74px;
      height: 62px;
      margin: 0 auto;
      margin-bottom: 15px;
      display: block;
    }

    .tipsText {
      margin-bottom: 10px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-size: 14px;
    }
  }
}
</style>

<style lang="less">
.van-search--show-action {
  background: #fff;
}
.van-search__content {
  border: 1px solid #eeeeee;
  background: #fff;
  .van-search--show-action {
    padding-right: 40px !important;
  }
}
.van-search__action {
  padding: 0 8px 0 20px;
}
</style>

